import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';

const Footer = () => {
  return (
    <div>

      <footer>

        <nav class="navbar navbar-dark bg-dark">
          <small id="footerColor">&copy; Copyright 2020, Sydney Jo Goodwill</small>
        </nav>

      </footer>
    </div>
  )
};

export default Footer;